import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class QualitySerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
